import { Program, ProgramRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const createProgram: (
  fetchContext: FetchContext,
  program: Program,
  accessToken?: string,
) => Promise<ProgramRef> = (fetchContext, program, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/programs`,
  {
    method: 'POST',
    body: JSON.stringify(program),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<ProgramRef>(fetchContext.errorStore, response, 'create program'));
